/**
 * These settings will be applied to all highcharts in this applications.
 * Chart specific settings should not be done here. 
 * 
 * Any look and feel settings must be changed in the config/highcharts-theme.js 
 */

module.exports = {
  title: {
    text: ''
  },
  credits: {
    enabled: false
  },
  legend: {
    layout: 'horizontal',
    align: 'right',
    verticalAlign: 'top',
    floating: true,
    useHTML: true
  },
  plotOptions: {
    pie: {
      states: {
        hover: {
          enabled: false
        }
      },
      allowPointSelect: false,
      dataLabels:
      {
        enabled: false
      },
      showInLegend: false,
      slicedOffset: 2
    }
  }
}